import { getCookie } from '../cookies/getCookie.js';
import { setSessionCookie } from '../cookies/setSessionCookie.js';
import { isString } from '../isString/isString.js';
import { storage } from '../storage/storage.js';

const KEY = "GU_geo_country";
const KEY_OVERRIDE = "gu.geo.override";
const URL = "https://api.nextgen.guardianapps.co.uk/geolocation";
const COUNTRY_REGEX = /^[A-Z]{2}$/;
const isValidCountryCode = (country) => isString(country) && COUNTRY_REGEX.test(country);
let locale;
const getLocale = async () => {
  if (locale) {
    return locale;
  }
  const geoOverride = storage.local.get(KEY_OVERRIDE);
  if (isValidCountryCode(geoOverride)) {
    return locale = geoOverride;
  }
  const stored = getCookie({ name: "GU_geo_country" });
  if (stored && isValidCountryCode(stored)) {
    return locale = stored;
  }
  try {
    const { country } = await fetch(URL).then(
      (response) => response.json()
    );
    if (isValidCountryCode(country)) {
      setSessionCookie({ name: KEY, value: country });
      return locale = country;
    }
  } catch (e) {
  }
  return null;
};

export { getLocale };
